import { render, staticRenderFns } from "./SaGroupActionButton.vue?vue&type=template&id=2238fba2&"
import script from "./SaGroupActionButton.vue?vue&type=script&lang=js&"
export * from "./SaGroupActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports